import { useGetOrganization } from "@/api/services/main/organization";
import { LoadingPage } from "@/components/elements/Loading/Loading";
import { OrganizationForm } from "@/features/organization/components/OrganizationForm";
import { convertOrganizationToFormData } from "@/features/organization/utils/organizationConverts";

export const OrganizationEdit = () => {
  const { data: response, isLoading } = useGetOrganization();

  if (isLoading) return <LoadingPage />;
  if (!response?.data) return null;

  return <OrganizationForm defaultValues={convertOrganizationToFormData(response.data)} />;
};
